import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/",
    component: () =>
      import(/* webpackChunkName: "WebLayout" */ "@/layouts/WebLayout.vue"),
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "/",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/HomeView.vue"),
        meta: {
          requiresAuth: false,
          title: "SMAPA"
        }
      },
      {
        path: "/smapa/quienes-somos",
        name: "QuienesSomos",
        component: () =>
          import(
            /* webpackChunkName: "QuienesSomos" */ "@/views/Menu/QuienesSomosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Quienes Somos - SMAPA"
        }
      },
      {
        path: "/smapa/novedades",
        name: "Novedades",
        component: () =>
          import(
            /* webpackChunkName: "Novedades" */ "@/views/Web/NovedadesView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Quienes Somos - SMAPA"
        }
      },
      {
        path: "/:nombre",
        name: "Pagina",
        component: () =>
          import(
            /* webpackChunkName: "Pagina" */ "@/views/Pagina/GenericoView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "SMAPA"
        }
      },
      {
        path: "/contenido/pagina/preview/:nombre",
        name: "PaginaPreview",
        component: () =>
          import(
            /* webpackChunkName: "PaginaPreview" */ "@/views/Pagina/PreviewView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Preview Página"
        }
      },
      {
        path: "/smapa/noticias",
        name: "NoticiasSmapa",
        component: () =>
          import(
            /* webpackChunkName: "noticias" */ "@/views/Noticias/NoticiasView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Noticias - SMAPA"
        }
      },
      {
        path: "/noticias",
        name: "Noticias",
        redirect: "/smapa/noticias"
      },
      {
        path: "/noticias/publicacion/:nombre",
        name: "Publicacion",
        component: () =>
          import(
            /* webpackChunkName: "Publicacion" */ "@/views/Noticias/PublicacionView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Noticia"
        }
      },
      {
        path: "/contenido/noticias/preview/:nombre",
        name: "PublicacionPreview",
        component: () =>
          import(
            /* webpackChunkName: "PublicacionPreview" */ "@/views/Noticias/PublicacionPreviewView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Noticia Preview"
        }
      },
      {
        path: "/noticias/categoria/:nombre",
        name: "Categoria",
        component: () =>
          import(
            /* webpackChunkName: "Categoria" */ "@/views/Noticias/CategoriaView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Noticias"
        }
      },
      {
        path: "/smapa/trabaja",
        name: "FormularioTrabaja",
        component: () =>
          import(
            /* webpackChunkName: "Avisos" */ "@/views/Formularios/TrabajaView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Trabaja con nosotros - SMAPA"
        }
      }

      // Legacy
      // {
      //   path: "/dev/organigrama-municipal",
      //   name: "Organigrama",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "OrganigramaMuni" */ "@/views/Municipalidad/OrganigramaMuniView.vue"
      //     ),
      //   meta: {
      //     title: "Organigrama Municipal - SMAPA"
      //   }
      // },
      // {
      //   path: "/dev/organigrama",
      //   name: "OrganigramaDos",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "OrganigramaMuni" */ "@/views/Municipalidad/OrganigramaView.vue"
      //     ),
      //   meta: {
      //     title: "Organigrama Municipal - SMAPA"
      //   }
      // },
      // {
      //   path: "/oficinas-y-telefonos-municipales",
      //   name: "Telefonos",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "telefonosMuni" */ "@/views/Web/TelefonosView.vue"
      //     ),
      //   meta: {
      //     requiresAuth: false,
      //     title: "Oficinas y Teléfonos - SMAPA"
      //   }
      // },
      // {
      //   path: "/tramites-y-pagos-online",
      //   name: "Tramites",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "tramites" */ "@/views/Web/TramitesView.vue"
      //     ),
      //   meta: {
      //     requiresAuth: false,
      //     title: "Trámites y pagos online - SMAPA"
      //   }
      // },
      // {
      //   path: "/galerias",
      //   name: "Galerias",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "galerias" */ "@/views/Galeria/GaleriaView.vue"
      //     ),
      //   meta: {
      //     requiresAuth: false,
      //     title: "Galerías - SMAPA"
      //   }
      // },
      // {
      //   path: "/galeria/:nombre",
      //   name: "DetalleGaleria",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "detallegaleria" */ "@/views/Galeria/DetalleGaleriaView.vue"
      //     ),
      //   meta: {
      //     requiresAuth: false,
      //     title: "Galeria"
      //   }
      // },
      // {
      //   path: "/comuna/:nombre",
      //   name: "Comuna",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "Comuna" */ "@/views/Comuna/GenericoView.vue"
      //     ),
      //   meta: {
      //     notLogged: false,
      //     requiresAuth: false,
      //     title: "Comuna"
      //   }
      // },
      // {
      //   path: "/municipalidad/:nombre",
      //   name: "Municipalidad",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "Municipalidad" */ "@/views/Municipalidad/GenericoView.vue"
      //     ),
      //   meta: {
      //     notLogged: false,
      //     requiresAuth: false,
      //     title: "SMAPA"
      //   }
      // },
      // {
      //   path: "/destacado/:nombre",
      //   name: "Destacado",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "Destacado" */ "@/views/Destacado/GenericoView.vue"
      //     ),
      //   meta: {
      //     notLogged: false,
      //     requiresAuth: false,
      //     title: "Destacado"
      //   }
      // },
      // {
      //   path: "/contacto/formulario",
      //   name: "Contacto",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "contacto" */ "@/views/Contacto/ContactoView.vue"
      //     ),
      //   meta: {
      //     title: "Formulario de Consultas - SMAPA"
      //   }
      // },
      // {
      //   path: "/concejo/municipal",
      //   name: "Concejo",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "concejo" */ "@/views/Municipalidad/ConcejoView.vue"
      //     ),
      //   meta: {
      //     title: "Concejo Municipal - SMAPA"
      //   }
      // },
      // {
      //   path: "/centros/atencion",
      //   name: "Cam",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "Cam" */ "@/views/Municipalidad/CamView.vue"
      //     ),
      //   meta: {
      //     title: "Centros de Atención Municipal - SMAPA"
      //   }
      // },
      // {
      //   path: "/organizaciones/ley-21146",
      //   name: "Organizaciones",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "organizaciones" */ "@/views/Municipalidad/OrganizacionesView.vue"
      //     ),
      //   meta: {
      //     title: "Ley 21.146 - SMAPA"
      //   }
      // },
      // {
      //   path: "/omil/ofertas",
      //   name: "OfertasOmil",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "oferta" */ "@/views/Web/OfertasOmilView.vue"
      //     ),
      //   meta: {
      //     title: "Ofertas Laborales OMIL - SMAPA"
      //   }
      // },
      // {
      //   path: "/category/noticia/",
      //   redirect: "/noticias"
      // },
      // { path: "/wp-content/*", redirect: "/" },
      // { path: "/category/*", redirect: "/" },
      // { path: "/tag/*", redirect: "/" }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
